import React, { useState } from "react";

// Components
import Login from "./Login";
import SignUp from "./SignUp";
import Verify from "./Verify";

export default function Main({ setState }) {
  const [phn, setPhn] = useState("");
  return (
    <>
      <span
        id="cartLoginSpan"
        data-bs-toggle="offcanvas"
        data-bs-target="#cartLogin"
      ></span>
      <Login phn={phn} setPhn={setPhn} setState={setState} />

      <span
        id="cartVerifySpan"
        data-bs-toggle="offcanvas"
        data-bs-target="#cartVerify"
      ></span>
      <Verify phn={phn} setState={setState} />

      <span
        id="cartSignUpSpan"
        data-bs-toggle="offcanvas"
        data-bs-target="#cartSignUp"
      ></span>
      <SignUp phn={phn} update={setState} />
    </>
  );
}
